import { apiClient } from './apiClient'

const STATUT_LABELS = {
  actif: 'Actif',
  inactif: 'Inactif'
}

const STATUT_BADGES = {
  actif: 'bg-success',
  inactif: 'bg-danger'
}

let cachedRoles = []

const normalizeRole = (role) => ({
  ...role,
  id: role.id,
  userCount: role.userCount ?? 0,
  protectedRole: role.protectedRole ?? role.code === 'admin'
})

export const rolesService = {
  async getAll(params = {}) {
    const data = await apiClient.get('/roles', params)
    cachedRoles = data.map(normalizeRole)
    return cachedRoles
  },

  async getActive() {
    const data = await apiClient.get('/roles/active')
    return data.map(normalizeRole)
  },

  getCachedAll() {
    return [...cachedRoles]
  },

  getCachedActive() {
    return cachedRoles.filter((role) => role.statut === 'actif')
  },

  getById(id) {
    return cachedRoles.find((r) => String(r.id) === String(id)) || null
  },

  async getSummary() {
    return apiClient.get('/roles/summary')
  },

  getLabel(id, roles = []) {
    const role = roles.find((r) => String(r.id) === String(id)) || this.getById(id)
    return role?.libelle || '—'
  },

  isProtected(roleOrId, roles = []) {
    if (typeof roleOrId === 'object' && roleOrId !== null) {
      return !!roleOrId.protectedRole || roleOrId.code === 'admin'
    }
    const role = roles.find((r) => String(r.id) === String(roleOrId))
    return !!role?.protectedRole || role?.code === 'admin'
  },

  async create(data) {
    const created = await apiClient.post('/roles', {
      libelle: data.libelle?.trim(),
      code: data.code?.trim().toLowerCase(),
      description: data.description?.trim() || '',
      statut: data.statut || 'actif'
    })
    return normalizeRole(created)
  },

  async update(id, data) {
    const payload = {}
    if (data.libelle !== undefined) payload.libelle = data.libelle
    if (data.code !== undefined) payload.code = data.code
    if (data.description !== undefined) payload.description = data.description
    if (data.statut !== undefined) payload.statut = data.statut

    const updated = await apiClient.put(`/roles/${id}`, {
      libelle: payload.libelle?.trim() ?? '',
      code: payload.code?.trim().toLowerCase() ?? '',
      description: payload.description?.trim() ?? '',
      statut: payload.statut ?? 'actif'
    })
    return normalizeRole(updated)
  },

  async updateStatut(id, statut) {
    const updated = await apiClient.patch(`/roles/${id}/statut`, { statut })
    return normalizeRole(updated)
  },

  async delete(id) {
    await apiClient.delete(`/roles/${id}`)
    return true
  },

  getStatutLabel(statut) {
    return STATUT_LABELS[statut] || statut
  },

  getStatutBadge(statut) {
    return STATUT_BADGES[statut] || 'bg-secondary'
  }
}
